import React from 'react';

function UnExpandIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 15 14" fill="none">
      <rect x="0.25" y="0.25" width="13.5334" height="13.5" rx="1.75" stroke="#718096" strokeWidth="0.5" />
      <path d="M10 6L7.5 9L5 6" stroke="#168884" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default UnExpandIcon;
